"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Microphone = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Microphone = function (_a) {
    var id = _a.id;
    var clipPathId = id ? "Microphone__clip0__".concat(id) : 'Microphone__clip0';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("g", { clipPath: "url(#".concat(clipPathId, ")") },
            react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.697 4.8v4.8a4.8 4.8 0 109.6 0V4.8a4.8 4.8 0 10-9.6 0zm13.032 8.64a.468.468 0 01.264.3.456.456 0 01-.096.396v.096a9.6 9.6 0 01-7.2 4.884V21.6h1.8a.6.6 0 01.6.6v1.2a.6.6 0 01-.6.6h-6a.6.6 0 01-.6-.6v-1.2a.6.6 0 01.6-.6h1.752v-2.424a9.6 9.6 0 01-7.2-4.884.612.612 0 010-.48c.047-.16.161-.29.312-.36l1.092-.504a.588.588 0 01.768.252 7.2 7.2 0 0012.588-.132.504.504 0 01.66-.216l1.26.588z", clipRule: "evenodd" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: clipPathId },
                react_1.default.createElement("path", { fill: "#fff", d: "M0 0H24V24H0z" })))));
};
exports.Microphone = Microphone;
//# sourceMappingURL=microphone.js.map